import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'MascaraMonto'
})
export class MascaraMontosPipe implements PipeTransform {
	transformNumWithDecimals(value: string) {
		const valueSplit = value.split('.');
		let num = valueSplit[0].replace(/\./g, '');
		num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
		num = num.split('').reverse().join('').replace(/^[\.]/, '');
		valueSplit[0] = num;
		const dosDecimales = valueSplit[1].substring(0, 2);
		valueSplit[1] = dosDecimales;
		return valueSplit.join(',');
	}

	transformNumWithOutDecimals(value: string) {
		let valueSplit = value;
		let num = valueSplit.replace(/\./g, '');
		num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
		num = num.split('').reverse().join('').replace(/^[\.]/, '');
		return valueSplit = num + ',00';
	}

	transform(value: any, args?: any): any {
		value ? value = value.toString() : null;
		if (value !== "" && value) {
			return value.indexOf('.') !== -1 ? this.transformNumWithDecimals(value) : this.transformNumWithOutDecimals(value);
		} else {
			return 0;
		}
	}

}
